var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-btn',{staticClass:"toSearchDashboard",attrs:{"icon":"","outlined":"","height":"36","width":"36","aria-label":"search","color":_vm.inverted ? 'inverted' : 'button-action'},on:{"click":_vm.onSearch}},[_c('v-icon',[_vm._v(_vm._s(_vm.mdiMagnify))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }